import { Component, OnInit, Input, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Subscription, Subject, BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { DomainCode } from 'src/app/models/common/model';
import { BackendListModel } from 'src/app/models/common/list.model';
import { user_data, user_data1 } from './table-data';
import { MatAccordion } from '@angular/material/expansion';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { CompanyApiService } from 'src/app/services/domain_code/company-api.service';
import { TaxIdentifierModel } from 'src/app/models/customer_master_model/tax-identifier-model';
import { CompanyModel, ICompanyModel } from 'src/app/models/customer_master_model/company-model';
import { CompanyTypeModel } from 'src/app/models/customer_master_model/company-type-model';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerStepper } from './cdk-customer-stepper';
import { BranchContactsModel, IBranchContactsModel } from '../branch-contact/branch-contact-model';
import {
    BranchInternalContactsModel,
    IBranchInternalContactsModel
} from '../branch-internal-contact/branch-internal-contact-model';
import { User_Tax_Identifiers } from 'src/app/models/customer_master_model/tax-identifiers';
import { Primary_Branch } from 'src/app/models/customer_master_model/primary-branch';
import { BankModel, IBankModel } from '../../form-fields/bank-details/bank-model';
import { EmbassyService } from 'src/app/services/embassy.service';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { AuthService } from 'src/app/services/auth.service';
import { GlobalLoaderService } from "../../../services/global-loader.service";

export const MY_FORMATS2 = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export interface option2 {
    icon: string;
    name: string;
}

type AOA = any[][];

@Component({
    selector: 'app-customer-stepper',
    templateUrl: './customer-stepper.component.html',
    styleUrls: ['./customer-stepper.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },// to set date in DD/MM/YYYY format
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS2 },//mm/yyyy date set
    ],
})
export class CustomerStepperComponent implements OnInit {
    @Input()
    customerObj: CompanyModel;

    @Input()
    isEditable: boolean = true;

    @Output()
    isEditableChange = new EventEmitter<boolean>();

    @Input()
    loaderSubject = new Subject<boolean>();

    @Input()
    Loader: boolean = true;

    @Output("back") back: EventEmitter<any> = new EventEmitter();

    @Output("addNew") addNew: EventEmitter<any> = new EventEmitter();

    @Output()
    closeCustomerForm = new EventEmitter<ICompanyModel>();

    @Output()
    refreshCustomer = new EventEmitter<string>();

    @Input()
    errorObj: any = {};

    forceRefreshTaxIdentifiers = new BehaviorSubject(null);
    forceRefreshBranchUrls = new BehaviorSubject(null);
    pulse: boolean = false;
    isCountryEditable: boolean = true;
    geo_url = ApiRoutes.Geo;
    country_url: string = `${this.geo_url}country/?name=::search::`;
    state_url: string = `${this.geo_url}state/?name=::search::`;
    city_url: string = `${this.geo_url}city/?name=::search::`;
    companyGroup_url = `${ApiRoutes.Company}group/?name=::search::`;
    companyType_url = `${ApiRoutes.Company}company_type/?search=::search::`;
    incorporation_type_url = `${ApiRoutes.Company}constitution/?search=::search::`;
    currencyUrl = `${ApiRoutes.CurrencyMaster}currency/?currency_code=::search::`;

    customerDetailsByGST;
    taxIdentifierList: BackendListModel<TaxIdentifierModel>;
    industryTypeList: BackendListModel<DomainCode>;
    branchUnitTypeList: BackendListModel<DomainCode>;
    // companyTypeList: BackendListModel<CompanyTypeModel>;
    kycTaxIdentifierList: TaxIdentifierModel[] = [];

    isNewAddress: boolean = true;
    isUpdateAddress: boolean = false;
    // addressList = [];
    branchUnitName = null;
    state = null;
    city = null;
    address = null;
    pincode = null;
    isCustomer: boolean;

    @ViewChild('errorInStep') stepper: CustomerStepper;

    refreshCustomerDirectoryObj: BranchContactsModel;
    refreshCustomerEngagementObj: BranchInternalContactsModel;
    customerDirectoryList: BackendListModel<IBranchContactsModel>
    customerEngagementList: BackendListModel<IBranchInternalContactsModel>
    // branch_url = `${ApiRoutes.Company}branch/?company=23132722-912e-47cb-b5fc-619532a995ca`;

    panelTitle: string;
    selectedBranchContact = new BehaviorSubject(null);
    selectedBranchInternalContact = new BehaviorSubject(null);
    editBranchContact: boolean = true;
    editBranchInternalContact: boolean = true;

    displayedColumns: string[] = ['name', 'email', 'profile', 'phone', 'action'];
    displayedColumns1: string[] = ['name', 'email', 'function', 'phone', 'action'];

    refreshBankObj: BankModel;
    bankDetailsList: BackendListModel<IBankModel>;
    selectedBank = new BehaviorSubject(null);


    checked: boolean = false;
    counter: number = 0;
    counter1: number = 0;
    counter2: number = 0;
    hr: boolean = false;
    gstin: boolean = false;

    upload: boolean = true;
    logo: boolean = false;
    title = 'dropzone';
    labelPosition: 'before' | 'after' = 'after';
    user_data = user_data;
    user_data1 = user_data1;
    toggler: boolean = false;
    companyName: string = "";

    //mat-slider
    autoTicks = false;
    disabled = false;
    invert = false;
    max_credit_limit = 500000;
    min_credit_limit = 0;
    showTicks = false;
    step = 1000;
    thumbLabel = true;
    credit = 0;
    vertical = false;
    tickInterval = 1;

    getSliderTickInterval(): number | 'auto' {
        if (this.showTicks) {
            return this.autoTicks ? 'auto' : this.tickInterval;
        }

        return 0;
    }


    visibility = {
        card1: true,
        card2: true,
        card3: true,
        card4: true,
        card5: true,
        card6: true,
        card7: true,
    }

    @ViewChild(MatAccordion) accordion!: MatAccordion;

    editableToggle() {
        this.isEditable = !this.isEditable;
    }

    changed(event: any) {
        var val = event.target.value;
        var input = event.target.id;
        for (let i = 1; i < 10; i++) {
            if (input === "input" + i) {
                console.log(input)
                if (val != "") {
                    this.counter = this.counter + 8;
                    console.log(this.counter);
                }
                if (val === "") {
                    this.counter = this.counter - 8;
                    console.log(this.counter);
                }
                ;
            }
        }
    }

    changed1(event: any) {
        var val = event.target.value;
        var input = event.target.id;
        for (let i = 10; i < 23; i++) {
            if (input === "input" + i) {
                console.log(input)
                if (val != "") {
                    this.counter1 = this.counter1 + 9;
                    console.log(this.counter1);
                }
                if (val === "") {
                    this.counter1 = this.counter1 - 9;
                    console.log(this.counter1);
                }
                ;
            }
        }
    }

    // onEnter() {  //smart device toggle
    //   var element = document.getElementById("day");
    //   element!.classList.toggle("show");
    // }
    edi() {
        var element = document.getElementById("edi");
        element!.classList.toggle("show");
    }

    edit() {
        document.getElementById("fci")!.classList.toggle("flip");
        document.getElementById("cardBg")!.classList.toggle("display");

    }

    // showP: boolean = false;
    prime() {  //show primary
        document.getElementById("prime")!.classList.toggle("visible");
        // this.showP = !this.showP;
    }


    openDD(title: string, element, booleanVal) {
        this.panelTitle = title;
        if (this.panelTitle == 'Customer Directory') {
            this.editBranchContact = booleanVal;
            if (element == null) {
                this.selectedBranchContact.next(null);
            } else {
                this.selectedBranchContact.next(element);
            }
            this.forceRefreshBranchUrls.next(this.customerObj?.id)
        }
        if (this.panelTitle == 'Customer Engagement') {
            this.editBranchInternalContact = booleanVal;
            if (element == null) {
                this.selectedBranchInternalContact.next(null);
            } else {
                this.selectedBranchInternalContact.next(element);
            }
        }
        if (this.panelTitle == 'KYC Details') {
            this.forceRefreshTaxIdentifiers.next(this.customerObj.tax_identifiers);
        }
        if (this.panelTitle == 'Bank Details') {
            if (element == null) {
                this.selectedBank.next(null);
            } else {
                this.selectedBank.next(element);
            }
        }
        document.getElementById("mySidepanel")!.style.width = "493px";
        document.getElementById("mySidepanel")!.style.boxShadow = "0 0 0 99999px rgba(0, 0, 0, .5)";
    }

    closeDD() {
        document.getElementById("mySidepanel")!.style.width = "0";
        document.getElementById("mySidepanel")!.style.boxShadow = "none";
        if (this.panelTitle == 'Customer Directory') {
            this.refreshCustomerDirectoryObj = new BranchContactsModel();
        }
        if (this.panelTitle == 'Customer Engagement') {
            this.refreshCustomerEngagementObj = new BranchInternalContactsModel();
        }
        if (this.panelTitle == 'KYC Details') {

        }
        if (this.panelTitle == 'Bank Details') {
            this.refreshBankObj = new BankModel();
        }
    }

    export(): void {

        /* generate worksheet */
        // const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data1);

        // /* generate workbook and add the worksheet */
        // const wb: XLSX.WorkBook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // /* save to file */
        // XLSX.writeFile(wb, this.fileName1);
    }

    expandToggle(event: any) {

        if (this.toggler == false) {
            this.accordion.openAll();
            this.toggler = true;
            event.target.classList.replace('flaticon-maximize', 'flaticon-minimize')
            console.log(event.target.classList);
            console.log(this.toggler);
        } else if (this.toggler == true) {
            this.accordion.closeAll();
            this.toggler = false;
            // var icon = event.target.nextElementSibling;
            event.target.classList.replace('flaticon-minimize', 'flaticon-maximize')
            console.log(event.target.classList);
            console.log(this.toggler);
        }
        console.log(this.toggler);


    }

    @Input() requiredFileType: string | undefined;  //gets label from container-master-data
    @Output("ownfn") ownfn: EventEmitter<any> = new EventEmitter();//gets function from container-master-data

    data1: AOA = [[1, 2], [3, 4]];
    fileName1: string = 'dataFormat.xlsx';
    fileName = '';
    uploadProgress!: number;
    uploadSub!: Subscription;

    constructor(
        private _snackBar: MatSnackBar,
        @Inject(DOCUMENT) private document: Document,
        public dialog: MatDialog,
        private domainService: DomainCodeApiService,
        private companyService: CompanyApiService,
        private route: ActivatedRoute,
        private router: Router,
        public embassyService: EmbassyService,
        private authService: AuthService,
        private loaderService: GlobalLoaderService,
    ) {
    }


    logoUpload() {
        this.upload = false;
        this.logo = true;

    }

    cancelUpload() {
        this.uploadSub.unsubscribe();
        this.reset();
    }

    reset() {
        this.uploadProgress = 0;
        this.uploadSub.unsubscribe();
    }


    showDoc!: boolean;
    showCmplt!: boolean;
    docNotUpdate!: boolean;

    ngOnInit(): void {
        this.isCustomer = this.authService.isCustomer();
        this.resetComponent();
        this.prepareFormData();
        setTimeout(() => {
            this.route.queryParams.subscribe(params => {
                if ('id' in params) {
                    // this.isEditable = false; // Uncomment it when you add floating editable toggle
                    this.getCompanyById(params['id']);
                    this.getCustomerDirectoryList(params['id']);
                    this.getCustomerEngagementList(params['id']);
                    this.getBankDetailsList(params['id']);
                }
            });
        }, 1);

        this.loaderSubject.subscribe(item => {
            if (item) {
                this.Loader = item
            } else {
                this.isEditable = true;
                this.Loader = item
            }
        })
        console.log('this.customerObj', this.customerObj)
    }

    resetComponent() {
        this.isCountryEditable = true
        this.customerObj = new CompanyModel();
        this.refreshCustomerDirectoryObj = new BranchContactsModel();
        this.refreshCustomerEngagementObj = new BranchInternalContactsModel();
        this.resetAddressFields();
        this.showDoc = true;
        this.showCmplt = false;
        this.docNotUpdate = true;
        this.errorObj = {}
    }

    resetAddressFields() {
        this.state = null;
        this.resetBranchFields();
    }

    backToList() {
        this.resetComponent();
        this.isEditable = false;
        this.refreshCustomer.emit();
        this.back.emit();
        if (this.taxIdentifierList != null) {
            this.taxIdentifierList = null;
        }
        if (this.customerDirectoryList != null) {
            this.customerDirectoryList = null
        }
        if (this.customerEngagementList != null) {
            this.customerEngagementList = null
        }
        if (this.bankDetailsList != null) {
            this.bankDetailsList = null
        }
        this.router.navigate([], {
            queryParams: {
                'id': null,
            },
            queryParamsHandling: 'merge'
        });
        setTimeout(() => {
            this.Loader = true;
        }, 600);
    }


    todo1 = ['Signatory Details1', 'Signatory Details2'];

    addSignatory() {

        this.todo1.push(`Signatory Details${this.todo1.length + 1}`);
        console.log(this.todo1);
    }

    saveUpload() {
        this.showDoc = false;
        this.showCmplt = true;
    }

    to(a: any) {
        document.getElementById("card" + a)?.scrollIntoView({ block: "center", behavior: "smooth" });
        // this.scroller.scrollToAnchor("card4");
    }

    scrolltop() {
        document.getElementById("top")?.scrollIntoView({ block: "start", behavior: "smooth" });
        // window.scrollTo(0, 0);
    }

    scrolltop1() {
        document.getElementById("card4")?.scrollIntoView({ block: "center", behavior: "smooth" });
    }

    complete() {
        document.getElementById("step4")!.innerHTML = "Completion";
        // console.log(document.getElementById("step3")!.innerHTML);
        document.getElementById("i4")!.classList.replace('flaticon-accounting', 'flaticon-accept');
        // console.log(document.getElementById("i3")!.classList);
        this.showDoc = false;
        this.showCmplt = true;
        // console.log(this.showDoc, this.showCmplt);
    }

    addRow() {
        const user_data =
            {
                fromDay: undefined,
                toDay: undefined,
                tariff: undefined,
                pulse: "Per Day",

            };

        this.user_data.push(user_data);
        console.log(this.user_data);
    }

    prepareFormData() {
        // Get Company Type list
        // this.companyService.getCompanyTypeList().subscribe({
        //     next: response => {
        //         this.companyTypeList = response;
        //     },
        //     error: error => {
        //         console.log(error)
        //         return error;
        //     }
        // });

        // Get Industry Type list
        this.domainService.getByGroup('Company_IndustryType').subscribe({
            next: response => {
                this.industryTypeList = response;
            },
            error: error => {
                console.log(error)
                return error;
            }
        });

        // Get Branch Unit Type list
        this.domainService.getByGroup('BranchUnitName').subscribe({
            next: response => {
                this.branchUnitTypeList = response;
            },
            error: error => {
                console.log(error)
                return error;
            }
        });
    }

    // Get Company by Id
    getCompanyById(id) {
        this.companyService.getCompanyById(id).subscribe({
            next: response => {
                this.customerObj.savePayloadToModel(response);
                // this.addressList = [ ...response.secondary_branches];
                if (this.customerObj.country == null) {
                    this.isCountryEditable = true;
                } else {
                    this.isCountryEditable = false;
                    this.state_url = `${this.geo_url}state/?name=::search::&country=${this.customerObj.country.id}`;
                    // this.getTaxIdentifierList(this.customerObj.country.id)
                }
                if (this.customerObj.id != null) {
                    this.getKYCTaxIdentifierList(this.customerObj.country.id, this.customerObj.tax_identifiers)
                }
                this.Loader = false; //this set the Loader while loading the data for customer
                this.forceRefreshTaxIdentifiers.next(this.customerObj.tax_identifiers);
                return response
            },
            error: error => {
                return error;
            }
        })
    }

    // Event On Country Change
    getFieldsOnCountryChange(country) {
        this.resetAddressFields();
        if (country !== null && country !== undefined) {
            if (this.customerObj.country == null || this.customerObj.country.id != country.id) {
                if (this.customerObj.id == null) {
                    this.customerObj = new CompanyModel(); // reset customer if country changes
                }
                this.customerDetailsByGST = null;
                this.customerObj.country = country;
                this.errorObj.country = null;
                this.customerObj.state = null;
                // this.stateDisabled=false;
                this.state_url = `${this.geo_url}state/?name=::search::&country=${country.id}`;

                this.getTaxIdentifierList(country.id)
            }
        } else {
            this.customerObj.state = null;
            // this.stateDisabled = true;
        }
    }

    onB2CChange(event: boolean) {
        this.customerObj.is_b2c = event
        this.getTaxIdentifierList(this.customerObj.country.id, event ? 'customer' : 'business')
    }

    // Get Tax Identifier list
    getTaxIdentifierList(countryId: string, customerType = 'business') {
        this.companyService.getTaxIdentifierByCountry(countryId, customerType).subscribe({
            next: response => {
                this.taxIdentifierList = response;

                for (let i = 0; i < this.taxIdentifierList.results.length; i++) {
                    if (this.taxIdentifierList.results[i] != null) {
                        if (this.taxIdentifierList.results[i].is_hidden == false && this.taxIdentifierList.results[i].show_id_value_field == true) {
                            this.customerObj.tax_identifiers[i] = new User_Tax_Identifiers();
                            this.customerObj.tax_identifiers[i].tax_identifier = this.taxIdentifierList.results[i];
                        } else {
                            this.customerObj.tax_identifiers[i] = null;
                        }
                    }
                }

                let i = 0;
                while (i < this.customerObj.tax_identifiers.length) {
                    if (this.customerObj.tax_identifiers[i] === null) {
                        this.taxIdentifierList.results.splice(i, 1)
                        this.customerObj.tax_identifiers.splice(i, 1)
                    } else {
                        i++;
                    }
                }
                console.log("this.customerObj.tax_identifiers", this.customerObj.tax_identifiers)

            }, error: error => {
                console.log(error)
                return error;
            }
        });
    }

    // Company Group
    getCompanyGroup(event) {
        if (event != null) {
            this.errorObj.group = null;
        }
        if (typeof event == 'object' && event.id != null) {
            this.customerObj.group = {
                id: event.id,
                name: event.name,
            }
        }
        if (event == undefined || event == null) {
            this.customerObj.group = {
                id: null,
                name: null,
            }
        } else {
            this.customerObj.group = { ...event }
        }
    }

    // Get city url
    filterCityByStateID(state) {
        if (state !== null && state.id) {
            this.customerObj.state = state;
            this.city_url = `${this.geo_url}city/?name=::search::&state=${state.id}`;
            this.city = null;
        } else {
            this.city_url = `${this.geo_url}city/?name=::search::`;
            this.city = null;
        }
    }

    // Get Company details by GST Number
    getCompanyDetailsByGST(item, idx) {
        this.errorObj.tax_identifiers = [];
        if (this.errorObj?.tax_identifiers && item != null) {
            this.errorObj.tax_identifiers[idx] = [];
        }

        let reg = new RegExp(item.regex_validator)

        if (!reg.test(this.customerObj.tax_identifiers[idx].id_value)) {
            if (this.customerObj.tax_identifiers[idx].id_value == '') {
                this.customerObj.tax_identifiers[idx].id_value = null;
            } else {
                this._snackBar.open(`Invalid ${item.name}!`, 'Close', {
                    verticalPosition: 'top',
                    duration: 4000,
                });
                return;
            }
        }

        let payload = {
            tax_identifier: this.customerObj.id ? item.id : typeof this.customerObj.tax_identifiers[idx].tax_identifier == 'object' ? this.customerObj.tax_identifiers[idx].tax_identifier.id : this.customerObj.tax_identifiers[idx].tax_identifier,
            id_value: this.customerObj.tax_identifiers[idx].id_value,
        }

        if (item.dev_name == "gstin" && payload.id_value != null) {
            this.loaderService.showLoader();
            this.customerObj.primary_branch = new Primary_Branch();
            this.customerObj.secondary_branches = [];
            this.companyService.getCompanyDetailsByTaxIdentifier(payload).subscribe({
                next: response => {
                    if (response.is_new) {
                        this.customerObj.tax_identifiers[idx].is_auto_verified = true;
                        this.customerDetailsByGST = response;
                        this.state = { ...response.state };
                        if (response.address != null) {
                            for (let i = 0; i < response.address.length; i++) {
                                if (response.address[i]?.is_primary == true) {
                                    this.customerObj.saveGSTPayload(response, i);
                                } else {
                                    // @TODO: Uncomment below line to add secondary branches as well when required.
                                    // this.customerObj.saveGSTSecondaryBranches(response, i)
                                }
                            }
                        }
                        this.setPanFromGst(response);

                        if (response.type.startsWith('SEZ')) {
                            this.customerObj.is_sez = true;
                        }

                        let branches = []
                        if (this.customerObj.id != null) {
                            if (response.address != null) {
                                for (let i = 0; i < response.address.length; i++) {
                                    // @TODO: Remove the condition to add secondary branches as well when required.
                                    if (response.address[i].is_primary){
                                        branches.push(this.createMultipleBranchesPayload(response.address[i]))
                                    }
                                }
                            }

                            if (branches.length > 0) {
                                this.openWarningForBranchesCreation(branches, `Company details populated from GSTIN provided.`, `Do you want to save branch details?`, `Cancel`, `Yes`)
                            }
                        }
                    } else {
                        this.openWarningOnExistingGST(response.id, `Company with this GSTIN already exists in the system`, `Do you want to view/edit the details?`, `Cancel`, `Yes`);
                    }
                    this.loaderService.hideLoader();
                },
                error: error => {
                    console.log(error)
                    if (error.status > 499) {
                        this._snackBar.open("Something went wrong!! Please try again later.", 'Close', {
                            verticalPosition: 'top',
                            duration: 2000,
                        });
                    }
                    this.loaderService.hideLoader();
                    return error;
                }
            });
        }
    }

    getKYCTaxIdentifierList(countryId, kycDocList) {
        this.companyService.getTaxIdentifierByCountry(countryId).subscribe({
            next: response => {
                this.kycTaxIdentifierList = [];
                let difference = response.results.filter(item1 => !kycDocList.find(item2 => item2.tax_identifier?.id === item1.id));

                for (let i = 0; i < difference.length; i++) {
                    if (difference[i] != null) {
                        let data = [...this.kycTaxIdentifierList]
                        data.push(difference[i])
                        this.kycTaxIdentifierList = data;
                    }
                }
            },
            error: error => {
                console.log(error)
                return error;
            }
        });
    }

    setPanFromGst(response) {
        if (this.customerObj.id) {
            for (let i = 0; i < this.customerObj.tax_identifiers.length; i++) {
                if (this.customerObj.tax_identifiers[i].tax_identifier != null) {
                    if (this.customerObj.tax_identifiers[i].tax_identifier.dev_name == 'pan') {
                        this.customerObj.tax_identifiers[i].id_value = response.pan_no;
                    }
                }
            }
        } else {
            for (let i = 0; i < this.taxIdentifierList.results.length; i++) {
                if (this.taxIdentifierList.results[i] != null) {
                    if (this.taxIdentifierList.results[i].dev_name == 'pan') {
                        this.customerObj.tax_identifiers[i].id_value = response.pan_no;
                    }
                }
            }
        }
    }

    openWarningOnExistingGST(companyId, label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, description: description, label1: action1, label2: action2 }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                this.router.navigate([], {
                    queryParams: {
                        'id': companyId,
                    },
                    queryParamsHandling: 'merge'
                });
            } else {
                this.resetComponent();
            }
        })
    }

    openWarningForBranchesCreation(branches, label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, description: description, label1: action1, label2: action2 }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                this.loaderService.showLoader();
                this.saveMultipleBranches(branches)
            }
        })
    }

    onLegalNameChange() {
        if (!this.customerObj.trade_name) {
            this.customerObj.trade_name = this.customerObj.legal_name;
        }
    }

    resetBranchFields() {
        this.city = null;
        this.address = null;
        this.pincode = null;
        this.branchUnitName = null;
    }

    // @TODO add address cards
    addCompanyAddresses() {
        if (this.branchUnitName != null) {
            if (this.customerObj.id != null) {
                this.addNewBranch();
                return;
            }
            if (this.branchUnitName.dev_value == 'main_branch' && this.customerObj.primary_branch.address == null) {
                this.customerObj.state = { ...this.state };
                this.customerObj.primary_branch.state = this.state == null ? null : this.state;
                this.customerObj.primary_branch.city = this.city == null ? null : this.city;
                this.customerObj.primary_branch.pincode = this.pincode;
                this.customerObj.primary_branch.address = this.address;
                this.customerObj.primary_branch.unit_name = this.branchUnitName;
                this.resetBranchFields();
                return;
            }
            if (this.branchUnitName.dev_value == 'secondary_branch') {
                this.customerObj.secondary_branches.push({
                    state: this.state,
                    address: this.address,
                    pincode: this.pincode,
                    city: this.city == null ? null : { ...this.city },
                    company: this.customerObj.id,
                    unit_name: this.branchUnitName,
                })
                this.resetBranchFields();
                return;
            }
        } else {
            this.errorObj.unit_name = ['Please select the unit'];
        }
    }

    scrollToBranchDetails() {
        this.document.getElementById('branch_details')?.scrollIntoView({ block: "center", behavior: "smooth" });
    }

    addNewBranch() {
        let temp_branch = {}
        temp_branch = {
            address: this.address,
            pincode: this.pincode,
            city: this.city == null ? null : this.city,
            company: this.customerObj.id,
            unit_name: this.branchUnitName
        }
        this.saveCompanyBranch(temp_branch);
        this.resetBranchFields();
    }

    patchPrimaryAddress() {
        this.isNewAddress = false;
        this.isUpdateAddress = true;
        this.state = this.customerObj.primary_branch.state
        this.city = this.customerObj.primary_branch.city
        this.address = this.customerObj.primary_branch.address;
        this.pincode = this.customerObj.primary_branch.pincode;
        this.branchUnitName = this.customerObj.primary_branch.unit_name;
        this.scrollToBranchDetails();
    }

    branchIndex: number = null;

    patchSecondaryAddress(item, idx) {
        this.isNewAddress = false;
        this.isUpdateAddress = true;
        this.state = this.customerObj.secondary_branches[idx].state
        this.city = item.city
        this.address = item.address;
        this.pincode = item.pincode;
        this.branchUnitName = item.unit_name;
        this.branchIndex = idx;
        this.scrollToBranchDetails();
    }

    updateAddress() {
        if (this.branchUnitName.dev_value == 'main_branch') {
            if (this.branchIndex != null) {
                this.secondaryBranchUpdate();
                return;
            }
            this.primaryBranchUpdate();
            return;
        }
        if (this.branchUnitName.dev_value == 'secondary_branch') {
            this.secondaryBranchUpdate();
            return;
        }
    }

    primaryBranchUpdate() {
        this.customerObj.primary_branch.unit_name = this.branchUnitName;
        this.customerObj.primary_branch.address = this.address;
        this.customerObj.primary_branch.pincode = this.pincode;
        this.customerObj.primary_branch.city = this.city == null ? null : this.city;
        this.customerObj.primary_branch.company = this.customerObj.id;
        if (this.customerObj.id) {
            this.saveCompanyBranch(this.customerObj.primary_branch);
        }
        this.resetBranchFields();
        this.isNewAddress = true;
        this.isUpdateAddress = false;
    }

    secondaryBranchUpdate() {
        if (this.branchIndex == null) {
            this.customerObj.secondary_branches.push({
                address: this.address,
                pincode: this.pincode,
                city: this.city == null ? null : this.city,
                company: this.customerObj.id,
                unit_name: this.branchUnitName,
            });
            if (this.customerObj.id) {
                this.saveCompanyBranch(this.customerObj.secondary_branches[this.customerObj.secondary_branches.length - 1]);
            }
        } else {
            this.customerObj.secondary_branches[this.branchIndex].unit_name = this.branchUnitName;
            this.customerObj.secondary_branches[this.branchIndex].address = this.address;
            this.customerObj.secondary_branches[this.branchIndex].pincode = this.pincode;
            this.customerObj.secondary_branches[this.branchIndex].city = this.city == null ? null : this.city;
            this.customerObj.secondary_branches[this.branchIndex].company = this.customerObj.id;
            if (this.customerObj.id) {
                this.saveCompanyBranch(this.customerObj.secondary_branches[this.branchIndex]);
            }
        }


        this.resetBranchFields();
        this.branchIndex = null;
        this.isNewAddress = true;
        this.isUpdateAddress = false;
    }

    createMultipleBranchesPayload(branch) {
        const branchUnit = branch.is_primary ? this.branchUnitTypeList.results.find(unit => unit.dev_value == 'main_branch') : this.branchUnitTypeList.results.find(unit => unit.dev_value == 'secondary_branch')

        return {
            address: branch.full_address,
            pincode: branch.pncd,
            city: branch.city == null ? null : branch.city,
            company: this.customerObj.id,
            is_primary: branch.is_primary,
            unit_name: branchUnit,
        }
    }

    filterBranchData(branch) {
        let data = { ...branch }
        let keysToTransform = ['state', 'city', 'unit_name']
        for (const key of keysToTransform) {
            if (data[key] != null && typeof data[key] == 'object') {
                data[key] = data[key].id;
            }
        }
        return data;
    }

    saveCompanyBranch(branch) {
        if (branch.id != null) {
            this.updateCompanyBranch(branch)
        } else {
            this.postCompanyBranch(branch)
        }
    }

    postCompanyBranch(branch) {
        this.companyService.postBranch(this.filterBranchData(branch)).subscribe({
            next: response => {
                this._snackBar.open("Branch added successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.customerObj.savePayloadToModel(response);
                return response;
            },
            error: error => {
                console.log(error);
                return this.catchError(error);
            }
        })
    }

    updateCompanyBranch(branch) {
        this.companyService.putBranch(this.filterBranchData(branch), branch.id).subscribe({
            next: response => {
                this._snackBar.open("Branch updated successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.customerObj.savePayloadToModel(response);
                return response;
            },
            error: error => {
                console.log(error);
                return this.catchError(error);
            }
        })
    }

    saveMultipleBranches(branches) {
        const payload = branches.map(branch => this.filterBranchData(branch))

        this.companyService.postMultipleBranch({ branches: payload }).subscribe({
            next: response => {
                this._snackBar.open("Branches created Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                let secondary_branches = []
                this.customerObj.secondary_branches = []
                for (let i = 0; i < response.length; i++) {
                    if (response[i].is_primary) {
                        response[i].state = this.customerObj.state
                        this.patchPrimaryBranchOnMultipleSave(response[i])
                    } else {
                        response[i].state = this.customerObj.state
                        secondary_branches.push(response[i])
                    }
                }
                this.customerObj.secondary_branches = [...secondary_branches]
                this.loaderService.hideLoader();
                console.log(response)
            },
            error: error => {
                this.loaderService.hideLoader();
                this._snackBar.open("Branches creation failed!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                console.log(error)
            }
        });
    }

    patchPrimaryBranchOnMultipleSave(data) {
        this.customerObj.primary_branch = new Primary_Branch()
        this.customerObj.primary_branch.id = data.id;
        this.customerObj.primary_branch.is_active = data.is_active;
        this.customerObj.primary_branch.address = data.address;
        this.customerObj.primary_branch.pincode = data.pincode;
        this.customerObj.primary_branch.city = data.city;
        this.customerObj.primary_branch.state = data.state;
        this.customerObj.primary_branch.updated_at = data.updated_at;
        this.customerObj.primary_branch.created_at = data.created_at;
        this.customerObj.primary_branch.created_by = data.created_by;
        this.customerObj.primary_branch.updated_by = data.updated_by;
        this.customerObj.primary_branch.unit_name = data.unit_name;
        this.customerObj.primary_branch.company = data.company;
    }

    saveCustomer() {
        this.loaderService.showLoader();
        if (this.customerObj.id != null) {
            this.updateCustomerFormTab1(this.customerObj.id, this.customerObj.getSavePayload())
        } else {
            this.postCustomerFormTab1(this.customerObj.getSavePayload())
        }
    }

    postCustomerFormTab1(data) {
        this.companyService.postCompany(data).subscribe({
            next: response => {
                this._snackBar.open("Customer created Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.customerObj.savePayloadToModel(response);
                this.isCountryEditable = false
                this.getKYCTaxIdentifierList(response.country.id, response.tax_identifiers);
                this.loaderService.hideLoader();
                return response;
            },
            error: error => {
                this.stepper.selectStepByIndex(0);
                console.log(error);
                this.loaderService.hideLoader();
                return this.catchError(error);
            }
        });
        this.scrolltop();
    }

    updateCustomerFormTab1(id, data) {
        // if (data.tax_identifiers.length) {
        //     for (let i = 0; i < data.tax_identifiers.length; i++) {
        //         if (typeof data.tax_identifiers[i].tax_identifier == 'object') {
        //             data.tax_identifiers[i].tax_identifier = data.tax_identifiers[i].tax_identifier.id;
        //         }
        //     }
        // }
        this.companyService.updateCompany(id, data).subscribe({
            next: response => {
                this._snackBar.open("Customer updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.isCountryEditable = false;
                this.customerObj.savePayloadToModel(response);
                this.getKYCTaxIdentifierList(response.country.id, response.tax_identifiers);
                this.loaderService.hideLoader();
                return response;
            },
            error: error => {
                this.stepper.selectStepByIndex(0);
                this.loaderService.hideLoader();
                return this.catchError(error);
            }
        });
        this.scrolltop();
    }

    patchCompanyDetails() {
        let data = {
            credit_days: this.customerObj.credit_days,
            credit_limits: this.customerObj.credit_limits,
            credit_limits_currency: this.customerObj.credit_limits_currency,
            documents: this.customerObj.documents.map((item) => item.id),
            remarks: this.customerObj.remarks,
            max_teu_allocation: this.customerObj.max_teu_allocation,
        }
        this.companyService.patchCompany(this.customerObj.id, data).subscribe({
            next: response => {
                this._snackBar.open("KYC & credit details saved successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.customerObj.savePayloadToModel(response);
                this.scrolltop();
                return response;
            },
            error: error => {
                this.stepper.selectStepByIndex(2);
                return this.catchError(error);
            }
        });
    }

    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = { ...error.error };
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = { ...error.error };
            return error;
        }
    }

    getCustomerDirectoryList(companyId) {
        this.companyService.getBranchContact(companyId).subscribe({
            next: response => {
                this.customerDirectoryList = response;
            },
            error: error => {
                console.log(error)
                return error;
            }
        })
    }

    getCustomerEngagementList(companyId) {
        this.companyService.getBranchInternalContact(companyId).subscribe({
            next: response => {
                this.customerEngagementList = response;
            },
            error: error => {
                console.log(error)
                return error;
            }
        })
    }

    getBankDetailsList(companyId) {
        this.companyService.getBankDetailsByCompanyId(companyId).subscribe({
            next: response => {
                this.bankDetailsList = response;
            },
            error: error => {
                console.log(error)
                return error;
            }
        })
    }

    closeForm(event) {
        if (this.panelTitle == 'Customer Directory') {
            this.getCustomerDirectoryList(this.customerObj.id)
        }
        if (this.panelTitle == 'Customer Engagement') {
            this.getCustomerEngagementList(this.customerObj.id)
        }
        if (this.panelTitle == 'KYC Details') {
            if (event != null) {
                this.customerObj.savePayloadToModel(event);
            }
        }
        if (this.panelTitle == 'Bank Details') {
            this.getBankDetailsList(this.customerObj.id)
        }
        this.closeDD();
    }

    goToAddNewCustomer() {
        this.router.navigate([], {
            queryParams: {
                'id': null,
            },
            queryParamsHandling: 'merge'
        });
        setTimeout(() => {
            this.resetComponent();
            this.stepper.selectStepByIndex(0);
            this.isEditable = true;
            if (this.taxIdentifierList != null) {
                this.taxIdentifierList = null;
            }
            if (this.customerDirectoryList != null) {
                this.customerDirectoryList = null
            }
            if (this.customerEngagementList != null) {
                this.customerEngagementList = null
            }
            if (this.bankDetailsList != null) {
                this.bankDetailsList = null
            }
        }, 20);
    }

    navigateToListPage() {
        this.backToList();
        this.stepper.selectStepByIndex(0);
        document.getElementById("step4")!.innerHTML = "Bank Details & Agreement";
        document.getElementById("i4")!.classList.replace('flaticon-accept', 'flaticon-accounting');
        this.showDoc = true;
        this.showCmplt = false;
        // this.router.navigateByUrl(`master-data/customer-master`);
    }

    saveAgreementDetails() {
        if (this.customerObj.master_agreement_no != null && this.customerObj.master_agreement_no != '') {
            this.companyService.putAgreementDetails(this.customerObj.id, this.customerObj.getAgreementPayload()).subscribe({
                next: response => {
                    this._snackBar.open("Master agreement details saved successfully!", 'Close', {
                        verticalPosition: 'top',
                        duration: 3000,
                    });
                    this.complete();
                    return response;
                },
                error: error => {
                    return this.catchError(error);
                }
            })
        } else {
            this.complete();
        }
    }

    redirectToKycPage() {
        this.router.navigateByUrl(`/verify-customer-kyc/kyc-details?id=${this.customerObj.id}&country=${this.customerObj.country?.id}`);
    }
}

